

























































import Vue from 'vue';
import { API } from '@/api';
import { mapActions } from 'vuex';

export default Vue.extend({
  data: () => ({
    menuDate: false,
    openDialog: false,
    date: '',
    formatoFecha: 'DD/MM/YYYY',
    documento: {
      titulo: '',
      descripcion: '',
      archivoCSV: null,
      texto: '',
      tipoDeComprobante: '',
      serie: '',
      fechaDeEmision: '',
      periodo: '',
    },
  }),
  methods: {
    ...mapActions(['getCuentasList']),
    async sendFile() {
      try {
        this.loading = true;
        const adm = this.$store.getters.getAdmin;
        const cond = this.$store.getters.getCondo;
        this.documento.fechaDeEmision = this.$moment(this.date).format();
        this.documento.periodo = this.$moment(this.date).format();
        const req = this.documento;
        const datos = {adm, cond, req};
        console.log('SendFile datos: %o', req);
        const response = await this.$store.dispatch('matchCSV', {datos});
        this.openDialog = false;
        this.loading = false;
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response.data.message);
      }
    },
    close() {
      this.openDialog = false;
      this.showForm = false;
    },
  },
  computed: {
    computedDateFormatted() {
      return this.$moment(this.date).format(this.formatoFecha);
    },
  },
  watch: {
    openDialog() {
      if (this.openDialog) {
        // this.getData();
        this.date = (new Date()).toISOString();
      }
    },
  },
});
